import { useWizard } from "react-use-wizard";
import tradeInSteps from "./tradeInSteps";
import {
  IFillDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import EstimateStep from "../../../../../shared/wizard/steps/estimateStep";
import { IDataFormEstimate } from "../../../../estimate";

interface ITradeInStep_1 {
  isNextStepDisabled: boolean;
  onChange: (data: Partial<IFillDataWizardTradeIn>) => void;
  onChangePrice: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardTradeIn
  ) => void;
  dataFormEstimate: Partial<IFillDataWizardTradeIn>;
}

const TradeInStep_1 = ({
  isNextStepDisabled,
  onChange,
  onChangePrice,
  dataFormEstimate,
}: ITradeInStep_1) => {
  const { goToStep } = useWizard();

  const handleNexStep = () => {
    goToStep(tradeInSteps.step_2.step);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  const handleEstimatePrice = (value: number) => {
    onChangePrice(value, "estimatedPrice");
  };

  return (
    <div>
      <EstimateStep
        counterPage={{
          current: tradeInSteps.step_1.page,
          max: tradeInSteps.step_1.maxPage,
        }}
        mode="tradeIn"
        onEstimateForm={onChange}
        onEstimatePrice={handleEstimatePrice}
        onNexStep={handleNexStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default TradeInStep_1;
